<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <div class="bookingForms-view-tab">
      <BookingFormGeneral :bookingForm="bookingForm" @save="save" />
    </div>

    <div class="bookingForms-view-tab">
      <BookingFormFields :bookingForm="bookingForm" @save="save" />
    </div>
  </div>
</template>

<script>
import BookingFormGeneral from "./BookingFormGeneral.vue";
import BookingFormFields from "./BookingFormFields.vue";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    BookingFormGeneral,
    BookingFormFields,
  },
  data() {
    return {};
  },
  async created() {
    const bookingFormId = this.$route.params.id;
    await this.$store.dispatch("bookingForms/get", bookingFormId);
    await this.$store.dispatch("legalDocuments/getAll", false);
    console.log("Working on bookingForm", this.bookingForm);
  },
  methods: {
    async save() {
      try {
        // If any field does not have a label, throw an error
        const fieldEmptyLabel = this.bookingForm.fields.find(field => {
          return field.label == null || field.label == "";
        });
        if (fieldEmptyLabel != null) {
          this.$vs.notify({
            color: "danger",
            title: "Could not update",
            text: `All fields must have a label. Field of type "${fieldEmptyLabel.type}" does not have a label`,
            time: 5000,
          });
          return;
        }

        this.$vs.loading();
        console.log("Saving bookingForm", this.bookingForm);
        await this.$store.dispatch("bookingForms/update", this.bookingForm);
        this.$vs.notify({
          color: "success",
          title: "Updated",
          text: "Succesfully updated",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not update",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      bookingForm: "bookingForms/bookingForm",
      isLoading: "bookingForms/isLoading",
    }),
  },
};
</script>

<style lang="scss">
.bookingForms-view-tab {
  margin-left: 12px;
}
</style>
